import React, { useState } from 'react';
import {
  Container,
  Grid,
  Typography,
  Box,
  TextField,
  MenuItem,
} from '@mui/material';
import { mockCourses } from '../data/mockData';
import CourseCard from '../components/CourseCard';

const categories = ['Все', 'Стресс-менеджмент', 'Личностный рост', 'Коммуникации'];

const Courses = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('Все');

  const filteredCourses = mockCourses.filter((course) => {
    const matchesSearch = course.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      course.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory === 'Все' || course.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const handleBuy = (courseId: number) => {
    // Здесь будет логика покупки курса
    console.log('Покупка курса:', courseId);
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Курсы по психологии
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Выберите курс, который поможет вам развить навыки и улучшить качество жизни
        </Typography>
      </Box>

      <Box sx={{ mb: 4, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <TextField
          label="Поиск курсов"
          variant="outlined"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{ minWidth: 300 }}
        />
        <TextField
          select
          label="Категория"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          sx={{ minWidth: 200 }}
        >
          {categories.map((category) => (
            <MenuItem key={category} value={category}>
              {category}
            </MenuItem>
          ))}
        </TextField>
      </Box>

      <Grid container spacing={3}>
        {filteredCourses.map((course) => (
          <Grid item xs={12} sm={6} md={4} key={course.id}>
            <CourseCard course={course} onBuy={handleBuy} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Courses; 